<div class="lesson-detail-container" [ngClass]="rootClassName">
  <div class="lesson-detail-navigationbar z-3" [ngClass]="{'fixed':isLibrary}">
    <pop-ui-navigationbar [(state)]="navigation"></pop-ui-navigationbar>
  </div>
  <pop-ui-lesson-terms [lesson]="lesson" [stats]="stats"></pop-ui-lesson-terms>
</div>
